import { stripeService } from 'services/api';
import { useFunnel } from 'services/hooks/funnel';
import {
  getCheckoutURLs,
  getIsStudioCheckout,
} from 'services/hooks/stripe/helpers';
import { Funnel } from 'services/routes/locations';

type UseCheckoutParams = {
  createCheckoutSession: (
    priceId: string,
    onError?: (error: Error) => void
  ) => void;
};

const useCheckout = (): UseCheckoutParams => {
  const { getFunnel } = useFunnel();
  const aiMusicGeneratorFunnel = getFunnel(Funnel.AIMusicGenerator);

  const isStudioCheckout = getIsStudioCheckout(
    Boolean(aiMusicGeneratorFunnel),
    aiMusicGeneratorFunnel?.startedFrom
  );

  const createCheckoutSession = (
    priceId: string,
    onError?: (error: Error) => void
  ) => {
    const customCheckoutUrl = isStudioCheckout
      ? aiMusicGeneratorFunnel?.startedFrom
      : undefined;

    const { successURL, cancelURL } = getCheckoutURLs(
      isStudioCheckout,
      customCheckoutUrl
    );

    stripeService
      .createCheckoutSession(priceId, successURL, cancelURL)
      .then((response) => {
        window.location.href = response.checkoutURL;
      })
      .catch((error: Error) => {
        onError?.(error);
      });
  };

  return {
    createCheckoutSession,
  };
};

export default useCheckout;
